<template>
    <ubi-panel>
        <el-container>
            <el-aside width="25%">
                <h3>{{ $t("posts.components.otherMediasTitle") }}</h3>
                <p class="text-justify">{{ $t("posts.components.otherMediasText") }}</p>
            </el-aside>
            <el-container>
                <el-main>
                <el-row v-if="this.sitimmoUser.univers === 'IMMO'">
                    <el-col>
                    <el-form-item :label="$t('posts.components.otherMediasVirtualVisit')">
                        <UbiInputUrl v-model="post.visite_virtuelle" v-if="!desactiverChamp"></UbiInputUrl>
                        <el-input v-model="post.visite_virtuelle" v-else :disabled="true"></el-input>
                        <span class="help">{{ $t('posts.components.otherMediasVirtualVisitText') }}</span>
                    </el-form-item>
                    </el-col>
                </el-row>
                    <el-row>
                        <el-col>
                            <el-form-item :label="$t('posts.components.otherMediasAttachedFiles')">
                                <!-- :file-list="post.attachedFiles" => post.attachedFiles est traité en dessous -->
                                <el-upload
                                        style="display: inline"
                                        action=""
                                        :on-change="handleFileSelect"
                                        :on-remove="handleRemove"
                                        :auto-upload="false"
                                        multiple
                                        :file-list="[]"
                                        :limit="maximumPhotosAuthorizedToUpload"
                                    >
                                    <el-button  size="small" type="primary" :disabled="desactiverChamp" style="margin-left: -510px;">
                                        {{ $t('posts.components.otherMediasAttachedFilesButton') }}
                                    </el-button>
                                </el-upload>
                                <!-- template personalisé pour afficher l'url complète du fichier -->
                                <ul class="el-upload-list el-upload-list--text">
                                    <li v-for="attachedFile in post.attachedFiles" :key="attachedFile.name" tabindex="0" class="el-upload-list__item is-success">
                                        <a class="el-upload-list__item-name" v-if="attachedFile.url"><em class="el-icon-document"></em>{{ attachedFile.url }}</a>
                                        <a class="el-upload-list__item-name" v-else><em class="el-icon-document"></em>{{ attachedFile.name }}</a>
                                        <label class="el-upload-list__item-status-label"><em class="el-icon-upload-success el-icon-circle-check"></em></label>
                                        <em class="el-icon-close" v-on:click="handleRemove"></em>
                                    </li>
                                </ul>
                              <span class="help">{{ $t('posts.components.otherMediasAttachedFilesText') }}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col>
                            <el-form-item :label="$t('posts.components.otherMediasType')">
                              <el-select
                                  v-model="post.type_document_1"
                                  :placeholder="$t('posts.edit.selectTypePlaceholder')"
                                  clearable
                                  filterable
                              >
                                <el-option
                                    style="text-transform:capitalize"
                                    label="video"
                                    value="video"
                                />
                                <el-option
                                    style="text-transform:capitalize"
                                    label="audio"
                                    value="audio"
                                />
                              </el-select>
                              <span class="help">{{ $t('posts.components.otherMediasTypeTxt') }}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                      <el-col>
                        <el-form-item :label="$t('posts.components.otherMedias')">
                          <UbiInputUrl v-model="post.url_document_1" v-if="!desactiverChamp"></UbiInputUrl>
                          <el-input v-model="post.url_document_1" v-else :disabled="true"></el-input>
                          <span class="help">{{ $t('posts.components.otherMediasTxt') }}</span>
                        </el-form-item>
                      </el-col>
                    </el-row>
                </el-main>
            </el-container>
        </el-container>
    </ubi-panel>
</template>

<script>
import { Dialog, Upload } from 'element-ui'
import LinkPrevue from 'link-prevue'
import UbiInputUrl, { InputUrl } from '../../../components/forms/InputUrl'
import UbiPanel from '../../../components/Panel'

export default {
  name: 'PostOtherMediaUpload',
  inject: ['browserContext'],
  components: { UbiPanel, UbiInputUrl, ElDialog: Dialog, ElUpload: Upload, LinkPrevue },
  props: ['desactiverChamp', 'post'],
  data () {
    return {
    }
  },
  methods: {
    handleFileSelect (file, fileList) {
      const self = this
      const previewReader = new FileReader()
      previewReader.onload = function (readerEvt) {
        const preview = { sourceType: 'base64', sourceValue: readerEvt.target.result.replace(/^data:.+;base64,/, ''), name: file.name }
        if (!self.post.attachedFiles) {
          self.post.attachedFiles = []
        }
        self.post.attachedFiles.push(preview)
      }
      previewReader.readAsDataURL(file.raw)
    },
    handleRemove (fichierJoint) {
      this.post.attachedFiles.splice(this.post.attachedFiles.findIndex(v => v.name === fichierJoint.name), 1)
      this.$forceUpdate()
    },
    onChange () {
      this.$forceUpdate()
    }
  },
  computed: {
    maximumPhotosAuthorizedToUpload () {
      if (this.post.attachedFiles) {
        return 5 - this.post.attachedFiles.length
      } else {
        return 5
      }
    },
    sitimmoUser () {
      return this.$store.getters.getSitimmoUser
    }
  }
}
</script>

<style lang="scss">
    @import "@/theme/_bootstrap.scss";
    .PostOtherMediaUpload {
        &-dialog .el-dialog {
            width: 670px;
            max-width: 90%;
        }
        &-container {
            > *:not(:first-child) {
                border-left: 1px solid $gray-200;
            }
        }
        &-actions {
            text-align: right;
        }
    }
    .button {
        margin-top: 35px;
    }
    .flip-list-move {
        transition: transform 0.5s;
    }
    .no-move {
        transition: transform 0s;
    }
    .ghost {
        opacity: 0.5;
        background: #c8ebfb;
    }
    .list-group {
        min-height: 20px;
    }
    .list-group-item {
        cursor: move;
    }
    .list-group-item i {
        cursor: pointer;
    }
    .help{
      color: #8c939d;
      font-size: 12px;
    }
</style>
